import * as React from 'react';
import { withStyles, WithStyles } from '@material-ui/core';

import { ExpansionPanelProviders } from 'components/v2';
import styles from './ExtendedSchedulerProviderFilterPanel.styles';

type Props = WithStyles<typeof styles> & {
  onChange: (filteredProviders: string[]) => void;
  preFilteredProviders: string[];
  value: string[];
};

const ExtendedSchedulerProviderFilterPanel = (props: Props) => {
  const { classes, onChange, preFilteredProviders, value } = props;

  return (
    <ExpansionPanelProviders
      className={classes.expansionPanel}
      value={value}
      preFilteredProviders={preFilteredProviders}
      onChange={onChange}
    />
  );
};

export default withStyles(styles)(ExtendedSchedulerProviderFilterPanel);
